
export const projectsData = [
  {
    slug: 'tcs-power',
    category: 'Corporate Website',
    title: 'TCS Power',
    icon: 'Zap',
    description: 'A corporate digital showcase for an industrial manufacturer, highlighting technical specifications.',
    image: 'https://firebasestorage.googleapis.com/v0/b/darshnisoftware-100.firebasestorage.app/o/public%2Fprojects%2FTCS%20Power%2001.png?alt=media&token=c975f084-67ff-4612-8a5b-51630f32ed89',
    color: 'indigo',
    overview: "Developed a professional B2B website focusing on SEO and product showcasing. The site uses modern web standards to present complex industrial data in an easy-to-read format, facilitating bulk inquiries and international client outreach.",
    tech: ["React.js", "Tailwind CSS", "SEO Optimization"],
    features: ["Lead Generation", "Brand Authority"]
  },
  {
    slug: 'insighttube-ai',
    category: 'Data Analytics',
    title: 'InsightTubeAI',
    icon: 'BarChart',
    description: 'An AI-powered analytics dashboard that visualizes channel performance and provides SEO recommendations.',
    image: 'https://firebasestorage.googleapis.com/v0/b/darshnisoftware-100.firebasestorage.app/o/public%2Fprojects%2FInsighttube%20AI%2001.png?alt=media&token=913bf96d-ee9b-4221-9740-6e26aa227c5e',
    color: 'purple',
    overview: "Built a data-rich dashboard using React.js to visualize complex YouTube API data. The application analyzes public video tags, view counts, and engagement rates to generate actionable insights. The reactive frontend ensures that data charts and recommendations load instantly without refreshing the page.",
    tech: ["React.js", "Charting Libraries", "YouTube Data API", "AI Integration"],
    features: ["Data Visualization", "SEO Optimization"]
  },
  {
    slug: 'darshni-ai-studio',
    category: 'SaaS',
    title: 'Darshni AI Studio',
    icon: 'Bot',
    description: 'A browser-based creative studio allowing users to generate AI videos, images, and scripts.',
    image: 'https://firebasestorage.googleapis.com/v0/b/darshnisoftware-100.firebasestorage.app/o/public%2Fprojects%2FDarshni%20AI%20Studio%2001.png?alt=media&token=0eb8dc32-5a34-4d1f-8290-27c7d7f08885',
    color: 'cyan',
    overview: "We utilized React.js to build a responsive and intuitive control panel where users can interact with powerful AI models (Veo, Gemini). The frontend manages complex state handling to deliver a seamless \"prompt-to-creation\" workflow, making advanced AI accessible to non-technical creators.",
    tech: ["React.js", "WebGL", "AI Model Integration (API)"],
    features: ["Complex State Management", "Intuitive UX Design"]
  },
  {
    slug: 'the-notebook-plus',
    category: 'EdTech',
    title: 'The Notebook Plus',
    icon: 'School',
    description: 'A comprehensive EdTech platform offering Vedic Maths and academic courses, built with a reactive interface.',
    image: 'https://firebasestorage.googleapis.com/v0/b/darshnisoftware-100.firebasestorage.app/o/public%2Fprojects%2FThe%20Notebook%20Plus%2001.png?alt=media&token=25842350-4cb4-4e24-b0fd-c65299bfc6c1',
    color: 'green',
    overview: "Developed a dynamic Single Page Application (SPA) using React.js that offers a smooth, app-like experience on the web. The platform features interactive quizzes, video course modules, and a dedicated JNVST exam preparation section, all optimized for high speed and low data consumption.",
    tech: ["React.js", "REST APIs", "Modern UI Library"],
    features: ["Interactive Learning", "Real-time Quiz Engine"]
  },
  {
    slug: 'khelotsav',
    category: 'Desktop App',
    title: 'Khelotsav',
    icon: 'Laptop',
    description: "A high-performance desktop application delivering real-time cricket match data and live scorecards.",
    image: 'https://firebasestorage.googleapis.com/v0/b/darshnisoftware-100.firebasestorage.app/o/public%2Fprojects%2FKhelotsav%2001.png?alt=media&token=54cc468a-46f7-40e7-bcae-5e594a1963ba',
    color: 'blue',
    overview: "We engineered a standalone Windows application using Electron and Node.js. The app utilizes advanced DOM parsing and IPC (Inter-Process Communication) to scrape and render live match statistics in real-time, ensuring users get instant updates without browser latency. It features a custom lightweight UI optimized for performance using vanilla JavaScript.",
    tech: ["Electron (v40+)", "Node.js", "IPC Architecture", "HTML5/CSS3"],
    features: ["Offline-first architecture", "Local Storage", "Dynamic CSS animations"]
  },
  {
    slug: 'jobsarthi',
    category: 'Web Portal',
    title: 'JobSarthi',
    icon: 'Briefcase',
    description: 'A fast and clutter-free employment news portal designed to help students track government job updates.',
    image: 'https://firebasestorage.googleapis.com/v0/b/darshnisoftware-100.firebasestorage.app/o/public%2Fprojects%2FJobSarthi-01.png?alt=media&token=bef4b99c-856d-44fb-a141-17bcc296631e',
    color: 'orange',
    overview: "Designed with a \"Mobile-First\" approach using React.js, this portal aggregates data on government vacancies. The component-based architecture allows for rapid updates of admits cards and results, ensuring the site handles high student traffic with zero downtime.",
    tech: ["React.js", "Redux (State Management)", "Fast Loading UI"],
    features: ["High Traffic Handling", "Minimalist UI"]
  }
];
